import PropTypes from 'prop-types';

import ClassicIcon from 'components/ClassicIcon';
import SummaryItem from '../SummaryItem';
import { MainText, SubText } from '../primitives';

const RoomAndOfferInfo = ({ roomType, offer, isClassicOffer }) => (
  <SummaryItem icon="hotel" label="Room">
    <MainText>1x {roomType}</MainText>
    <SubText>
      {isClassicOffer && <ClassicIcon />}
      {offer}
    </SubText>
  </SummaryItem>
);

RoomAndOfferInfo.propTypes = {
  roomType: PropTypes.string.isRequired,
  offer: PropTypes.string.isRequired,
  isClassicOffer: PropTypes.bool,
};

RoomAndOfferInfo.defaultProps = {
  isClassicOffer: false,
};

export default RoomAndOfferInfo;
